import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import linkTag2Initializer from '../../util/linkTag2Initializer';
import { formatHeadingText } from '../../util/formatSportHeadingText';
import { appContext } from '../../util/decorators';
import TranslatedLink from '../TranslatedLink.jsx';
import TranslatedLinkLeague from '../TranslatedLinkLeague.jsx';
import PageHeading from '../PageHeading.jsx';
import PageWithSidebars from '../Page/PageWithSidebars.jsx';
import sportConfig from '../../config/sports';
import leagueConfig from '../../config/leagues';

const mapStateToProps = state => ({
  countrySportConfig: sportConfig[state.country],
  sportData: state.sportData,
  mappedSportRouteParam: state.mappedSportRouteParam,
  country: state.country,
});

@connect(mapStateToProps)
@linkTag2Initializer()
@appContext
export default class LeagueList extends React.PureComponent {
  render() {
    const { routeParams: { sports }, mappedSportRouteParam, countrySportConfig, country } = this.props;

    const t = this.context.app.t;
    const config = countrySportConfig[mappedSportRouteParam];

    if (!config) return null;

    return (
      <PageWithSidebars>
        <section className="league-page">
          <PageHeading firstPart={formatHeadingText(country, sports)} secondPart={t('LeagueIndex.heading')} />
          <div className="league-list">
          {
            _.map(config.leagues, leagueId => {
              const leagueLogo = require(`../../../assets/leagues/logo_${leagueId}.png`);
              const {name, slug} = leagueConfig[leagueId][country];

              return (
                <div key={leagueId} className="highlight-box league">
                  <TranslatedLinkLeague
                    routeParams={[sports, slug]}
                    name="LeaguePage"
                    className="section league-box"
                  >
                    <div className="icon">
                      <img src={leagueLogo} />
                    </div>
                    <h3 className="name">{name}</h3>
                  </TranslatedLinkLeague>
                </div>
              );
            })
          }
          </div>
        </section>
      </PageWithSidebars>
    );
  }
}

LeagueList.propTypes = {
  route: React.PropTypes.object,
  sportData: React.PropTypes.array,
  sports: React.PropTypes.object,
  country: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/component/Leagues/LeagueList.jsx